import { Link } from 'react-router-dom'
import { CIMSLinkProps } from './types'
import { Popover, Tooltip, Typography } from 'antd'

/**
 * returns an anchor or router {@link Link} for internal or external links
 *
 * for most usages of internal links, you should use {@link ProjectLink}, it wraps
 * this component
 *
 * @param props {@link CIMSLinkProps}
 */
const CIMSLink: React.FC<CIMSLinkProps> = ({ children, tooltip, ...props }) => {
  let link
  if (props.external === true) {
    const { href } = props
    if (!href) link = <Typography.Text disabled>{children}</Typography.Text>
    else
      link = (
        <a href={href} target="_blank" rel="noopener noreferrer">
          {children}
        </a>
      )
  }
  /**
   * for some reason, upgrading to the latest 17 version of react, react-dom,
   * and the latest version 5 of react-router-dom makes it so Link's definition
   * is no longer a JSX.Element...
   *
   * since the definitions are from definitely typed and not react-router-dom...
   * i'm going to ignore this since it works...
   */
  // @ts-expect-error
  else link = <Link to={props.to}>{children}</Link>
  if (typeof tooltip === 'string')
    return <Tooltip title={tooltip}>{link}</Tooltip>
  else if (tooltip) return <Popover {...tooltip}>{link}</Popover>
  return link
}

export default CIMSLink
